webpackJsonp([1],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(211);


/***/ },

/***/ 122:
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var utils = __webpack_require__(181);
	var React = global.React || __webpack_require__(49);
	
	var convertValidationsToObject = function convertValidationsToObject(validations) {
	
	  if (typeof validations === 'string') {
	
	    return validations.split(/\,(?![^{\[]*[}\]])/g).reduce(function (validations, validation) {
	      var args = validation.split(':');
	      var validateMethod = args.shift();
	
	      args = args.map(function (arg) {
	        try {
	          return JSON.parse(arg);
	        } catch (e) {
	          return arg; // It is a string if it can not parse it
	        }
	      });
	
	      if (args.length > 1) {
	        throw new Error('Formsy does not support multiple args on string validations. Use object format of validations instead.');
	      }
	
	      validations[validateMethod] = args.length ? args[0] : true;
	      return validations;
	    }, {});
	  }
	
	  return validations || {};
	};
	
	module.exports = {
	  getInitialState: function getInitialState() {
	    return {
	      _value: this.props.value,
	      _isRequired: false,
	      _isValid: true,
	      _isPristine: true,
	      _pristineValue: this.props.value,
	      _validationError: [],
	      _externalError: null,
	      _formSubmitted: false
	    };
	  },
	  contextTypes: {
	    formsy: React.PropTypes.object // What about required?
	  },
	  getDefaultProps: function getDefaultProps() {
	    return {
	      validationError: '',
	      validationErrors: {}
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    var configure = function () {
	      this.setValidations(this.props.validations, this.props.required);
	
	      // Pass a function instead?
	      this.context.formsy.attachToForm(this);
	      //this.props._attachToForm(this);
	    }.bind(this);
	
	    if (!this.props.name) {
	      throw new Error('Form Input requires a name property when used');
	    }
	
	    /*
	    if (!this.props._attachToForm) {
	      return setTimeout(function () {
	        if (!this.isMounted()) return;
	        if (!this.props._attachToForm) {
	          throw new Error('Form Mixin requires component to be nested in a Form');
	        }
	        configure();
	      }.bind(this), 0);
	    }
	    */
	    configure();
	  },
	
	  // We have to make the validate method is kept when new props are added
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    this.setValidations(nextProps.validations, nextProps.required);
	  },
	
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	
	    // If the value passed has changed, set it. If value is not passed it will
	    // internally update, and this will never run
	    if (!utils.isSame(this.props.value, prevProps.value)) {
	      this.setValue(this.props.value);
	    }
	
	    // If validations or required is changed, run a new validation
	    if (!utils.isSame(this.props.validations, prevProps.validations) || !utils.isSame(this.props.required, prevProps.required)) {
	      this.context.formsy.validate(this);
	    }
	  },
	
	  // Detach it when component unmounts
	  componentWillUnmount: function componentWillUnmount() {
	    this.context.formsy.detachFromForm(this);
	    //this.props._detachFromForm(this);
	  },
	
	  setValidations: function setValidations(validations, required) {
	
	    // Add validations to the store itself as the props object can not be modified
	    this._validations = convertValidationsToObject(validations) || {};
	    this._requiredValidations = required === true ? { isDefaultRequiredValue: true } : convertValidationsToObject(required);
	  },
	
	  // We validate after the value has been set
	  setValue: function setValue(value) {
	    this.setState({
	      _value: value,
	      _isPristine: false
	    }, function () {
	      this.context.formsy.validate(this);
	      //this.props._validate(this);
	    }.bind(this));
	  },
	  resetValue: function resetValue() {
	    this.setState({
	      _value: this.state._pristineValue,
	      _isPristine: true
	    }, function () {
	      this.context.formsy.validate(this);
	      //this.props._validate(this);
	    });
	  },
	  getValue: function getValue() {
	    return this.state._value;
	  },
	  hasValue: function hasValue() {
	    return this.state._value !== '';
	  },
	  getErrorMessage: function getErrorMessage() {
	    var messages = this.getErrorMessages();
	    return messages.length ? messages[0] : null;
	  },
	  getErrorMessages: function getErrorMessages() {
	    return !this.isValid() || this.showRequired() ? this.state._externalError || this.state._validationError || [] : [];
	  },
	  isFormDisabled: function isFormDisabled() {
	    return this.context.formsy.isFormDisabled();
	    //return this.props._isFormDisabled();
	  },
	  isValid: function isValid() {
	    return this.state._isValid;
	  },
	  isPristine: function isPristine() {
	    return this.state._isPristine;
	  },
	  isFormSubmitted: function isFormSubmitted() {
	    return this.state._formSubmitted;
	  },
	  isRequired: function isRequired() {
	    return !!this.props.required;
	  },
	  showRequired: function showRequired() {
	    return this.state._isRequired;
	  },
	  showError: function showError() {
	    return !this.showRequired() && !this.isValid();
	  },
	  isValidValue: function isValidValue(value) {
	    return this.context.formsy.isValidValue.call(null, this, value);
	    //return this.props._isValidValue.call(null, this, value);
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },

/***/ 180:
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = global.React || __webpack_require__(49);
	var Formsy = {};
	var validationRules = __webpack_require__(417);
	var formDataToObject = __webpack_require__(414);
	var utils = __webpack_require__(181);
	var Mixin = __webpack_require__(122);
	var HOC = __webpack_require__(416);
	var Decorator = __webpack_require__(415);
	var options = {};
	var emptyArray = [];
	
	Formsy.Mixin = Mixin;
	Formsy.HOC = HOC;
	Formsy.Decorator = Decorator;
	
	Formsy.defaults = function (passedOptions) {
	  options = passedOptions;
	};
	
	Formsy.addValidationRule = function (name, func) {
	  validationRules[name] = func;
	};
	
	Formsy.Form = React.createClass({
	  displayName: 'Formsy',
	  getInitialState: function getInitialState() {
	    return {
	      isValid: true,
	      isSubmitting: false,
	      canChange: false
	    };
	  },
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onSuccess: function onSuccess() {},
	      onError: function onError() {},
	      onSubmit: function onSubmit() {},
	      onValidSubmit: function onValidSubmit() {},
	      onInvalidSubmit: function onInvalidSubmit() {},
	      onValid: function onValid() {},
	      onInvalid: function onInvalid() {},
	      onChange: function onChange() {},
	      validationErrors: null,
	      preventExternalInvalidation: false
	    };
	  },
	
	  childContextTypes: {
	    formsy: React.PropTypes.object
	  },
	  getChildContext: function getChildContext() {
	    var _this = this;
	
	    return {
	      formsy: {
	        attachToForm: this.attachToForm,
	        detachFromForm: this.detachFromForm,
	        validate: this.validate,
	        isFormDisabled: this.isFormDisabled,
	        isValidValue: function isValidValue(component, value) {
	          return _this.runValidation(component, value).isValid;
	        }
	      }
	    };
	  },
	
	  // Add a map to store the inputs of the form, a model to store
	  // the values of the form and register child inputs
	  componentWillMount: function componentWillMount() {
	    this.inputs = [];
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.validateForm();
	  },
	
	  componentWillUpdate: function componentWillUpdate() {
	    // Keep a reference to input names before form updates,
	    // to check if inputs has changed after render
	    this.prevInputNames = this.inputs.map(function (component) {
	      return component.props.name;
	    });
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	
	    if (this.props.validationErrors && _typeof(this.props.validationErrors) === 'object' && Object.keys(this.props.validationErrors).length > 0) {
	      this.setInputValidationErrors(this.props.validationErrors);
	    }
	
	    var newInputNames = this.inputs.map(function (component) {
	      return component.props.name;
	    });
	    if (utils.arraysDiffer(this.prevInputNames, newInputNames)) {
	      this.validateForm();
	    }
	  },
	
	  // Allow resetting to specified data
	  reset: function reset(data) {
	    this.setFormPristine(true);
	    this.resetModel(data);
	  },
	
	  // Update model, submit to url prop and send the model
	  submit: function submit(event) {
	
	    event && event.preventDefault();
	
	    // Trigger form as not pristine.
	    // If any inputs have not been touched yet this will make them dirty
	    // so validation becomes visible (if based on isPristine)
	    this.setFormPristine(false);
	    var model = this.getModel();
	    this.props.onSubmit(model, this.resetModel, this.updateInputsWithError);
	    this.state.isValid ? this.props.onValidSubmit(model, this.resetModel, this.updateInputsWithError) : this.props.onInvalidSubmit(model, this.resetModel, this.updateInputsWithError);
	  },
	
	  mapModel: function mapModel(model) {
	
	    if (this.props.mapping) {
	      return this.props.mapping(model);
	    } else {
	      return formDataToObject.toObj(Object.keys(model).reduce(function (mappedModel, key) {
	
	        var keyArray = key.split('.');
	        var base = mappedModel;
	        while (keyArray.length) {
	          var currentKey = keyArray.shift();
	          base = base[currentKey] = keyArray.length ? base[currentKey] || {} : model[key];
	        }
	
	        return mappedModel;
	      }, {}));
	    }
	  },
	
	  getModel: function getModel() {
	    var currentValues = this.getCurrentValues();
	    return this.mapModel(currentValues);
	  },
	
	  // Reset each key in the model to the original / initial / specified value
	  resetModel: function resetModel(data) {
	    this.inputs.forEach(function (component) {
	      var name = component.props.name;
	      if (data && data.hasOwnProperty(name)) {
	        component.setValue(data[name]);
	      } else {
	        component.resetValue();
	      }
	    });
	    this.validateForm();
	  },
	
	  setInputValidationErrors: function setInputValidationErrors(errors) {
	    this.inputs.forEach(function (component) {
	      var name = component.props.name;
	      var args = [{
	        _isValid: !(name in errors),
	        _validationError: typeof errors[name] === 'string' ? [errors[name]] : errors[name]
	      }];
	      component.setState.apply(component, args);
	    });
	  },
	
	  // Checks if the values have changed from their initial value
	  isChanged: function isChanged() {
	    return !utils.isSame(this.getPristineValues(), this.getCurrentValues());
	  },
	
	  getPristineValues: function getPristineValues() {
	    return this.inputs.reduce(function (data, component) {
	      var name = component.props.name;
	      data[name] = component.props.value;
	      return data;
	    }, {});
	  },
	
	  // Go through errors from server and grab the components
	  // stored in the inputs map. Change their state to invalid
	  // and set the serverError message
	  updateInputsWithError: function updateInputsWithError(errors) {
	    var _this2 = this;
	
	    Object.keys(errors).forEach(function (name, index) {
	      var component = utils.find(_this2.inputs, function (component) {
	        return component.props.name === name;
	      });
	      if (!component) {
	        throw new Error('You are trying to update an input that does not exist. ' + 'Verify errors object with input names. ' + JSON.stringify(errors));
	      }
	      var args = [{
	        _isValid: _this2.props.preventExternalInvalidation || false,
	        _externalError: typeof errors[name] === 'string' ? [errors[name]] : errors[name]
	      }];
	      component.setState.apply(component, args);
	    });
	  },
	
	  isFormDisabled: function isFormDisabled() {
	    return this.props.disabled;
	  },
	
	  getCurrentValues: function getCurrentValues() {
	    return this.inputs.reduce(function (data, component) {
	      var name = component.props.name;
	      data[name] = component.state._value;
	      return data;
	    }, {});
	  },
	
	  setFormPristine: function setFormPristine(isPristine) {
	    this.setState({
	      _formSubmitted: !isPristine
	    });
	
	    // Iterate through each component and set it as pristine
	    // or "dirty".
	    this.inputs.forEach(function (component, index) {
	      component.setState({
	        _formSubmitted: !isPristine,
	        _isPristine: isPristine
	      });
	    });
	  },
	
	  // Use the binded values and the actual input value to
	  // validate the input and set its state. Then check the
	  // state of the form itself
	  validate: function validate(component) {
	
	    // Trigger onChange
	    if (this.state.canChange) {
	      this.props.onChange(this.getCurrentValues(), this.isChanged());
	    }
	
	    var validation = this.runValidation(component);
	    // Run through the validations, split them up and call
	    // the validator IF there is a value or it is required
	    component.setState({
	      _isValid: validation.isValid,
	      _isRequired: validation.isRequired,
	      _validationError: validation.error,
	      _externalError: null
	    }, this.validateForm);
	  },
	
	  // Checks validation on current value or a passed value
	  runValidation: function runValidation(component, value) {
	
	    var currentValues = this.getCurrentValues();
	    var validationErrors = component.props.validationErrors;
	    var validationError = component.props.validationError;
	    value = arguments.length === 2 ? value : component.state._value;
	
	    var validationResults = this.runRules(value, currentValues, component._validations);
	    var requiredResults = this.runRules(value, currentValues, component._requiredValidations);
	
	    // the component defines an explicit validate function
	    if (typeof component.validate === "function") {
	      validationResults.failed = component.validate() ? [] : ['failed'];
	    }
	
	    var isRequired = Object.keys(component._requiredValidations).length ? !!requiredResults.success.length : false;
	    var isValid = !validationResults.failed.length && !(this.props.validationErrors && this.props.validationErrors[component.props.name]);
	
	    return {
	      isRequired: isRequired,
	      isValid: isRequired ? false : isValid,
	      error: function () {
	
	        if (isValid && !isRequired) {
	          return emptyArray;
	        }
	
	        if (validationResults.errors.length) {
	          return validationResults.errors;
	        }
	
	        if (this.props.validationErrors && this.props.validationErrors[component.props.name]) {
	          return typeof this.props.validationErrors[component.props.name] === 'string' ? [this.props.validationErrors[component.props.name]] : this.props.validationErrors[component.props.name];
	        }
	
	        if (isRequired) {
	          var error = validationErrors[requiredResults.success[0]];
	          return error ? [error] : null;
	        }
	
	        if (validationResults.failed.length) {
	          return validationResults.failed.map(function (failed) {
	            return validationErrors[failed] ? validationErrors[failed] : validationError;
	          }).filter(function (x, pos, arr) {
	            // Remove duplicates
	            return arr.indexOf(x) === pos;
	          });
	        }
	      }.call(this)
	    };
	  },
	
	  runRules: function runRules(value, currentValues, validations) {
	
	    var results = {
	      errors: [],
	      failed: [],
	      success: []
	    };
	    if (Object.keys(validations).length) {
	      Object.keys(validations).forEach(function (validationMethod) {
	
	        if (validationRules[validationMethod] && typeof validations[validationMethod] === 'function') {
	          throw new Error('Formsy does not allow you to override default validations: ' + validationMethod);
	        }
	
	        if (!validationRules[validationMethod] && typeof validations[validationMethod] !== 'function') {
	          throw new Error('Formsy does not have the validation rule: ' + validationMethod);
	        }
	
	        if (typeof validations[validationMethod] === 'function') {
	          var validation = validations[validationMethod](currentValues, value);
	          if (typeof validation === 'string') {
	            results.errors.push(validation);
	            results.failed.push(validationMethod);
	          } else if (!validation) {
	            results.failed.push(validationMethod);
	          }
	          return;
	        } else if (typeof validations[validationMethod] !== 'function') {
	          var validation = validationRules[validationMethod](currentValues, value, validations[validationMethod]);
	          if (typeof validation === 'string') {
	            results.errors.push(validation);
	            results.failed.push(validationMethod);
	          } else if (!validation) {
	            results.failed.push(validationMethod);
	          } else {
	            results.success.push(validationMethod);
	          }
	          return;
	        }
	
	        return results.success.push(validationMethod);
	      });
	    }
	
	    return results;
	  },
	
	  // Validate the form by going through all child input components
	  // and check their state
	  validateForm: function validateForm() {
	    var _this3 = this;
	
	    // We need a callback as we are validating all inputs again. This will
	    // run when the last component has set its state
	    var onValidationComplete = function () {
	      var allIsValid = this.inputs.every(function (component) {
	        return component.state._isValid;
	      });
	
	      this.setState({
	        isValid: allIsValid
	      });
	
	      if (allIsValid) {
	        this.props.onValid();
	      } else {
	        this.props.onInvalid();
	      }
	
	      // Tell the form that it can start to trigger change events
	      this.setState({
	        canChange: true
	      });
	    }.bind(this);
	
	    // Run validation again in case affected by other inputs. The
	    // last component validated will run the onValidationComplete callback
	    this.inputs.forEach(function (component, index) {
	      var validation = _this3.runValidation(component);
	      if (validation.isValid && component.state._externalError) {
	        validation.isValid = false;
	      }
	      component.setState({
	        _isValid: validation.isValid,
	        _isRequired: validation.isRequired,
	        _validationError: validation.error,
	        _externalError: !validation.isValid && component.state._externalError ? component.state._externalError : null
	      }, index === _this3.inputs.length - 1 ? onValidationComplete : null);
	    });
	
	    // If there are no inputs, set state where form is ready to trigger
	    // change event. New inputs might be added later
	    if (!this.inputs.length && this.isMounted()) {
	      this.setState({
	        canChange: true
	      });
	    }
	  },
	
	  // Method put on each input component to register
	  // itself to the form
	  attachToForm: function attachToForm(component) {
	
	    if (this.inputs.indexOf(component) === -1) {
	      this.inputs.push(component);
	    }
	
	    this.validate(component);
	  },
	
	  // Method put on each input component to unregister
	  // itself from the form
	  detachFromForm: function detachFromForm(component) {
	    var componentPos = this.inputs.indexOf(component);
	
	    if (componentPos !== -1) {
	      this.inputs = this.inputs.slice(0, componentPos).concat(this.inputs.slice(componentPos + 1));
	    }
	
	    this.validateForm();
	  },
	  render: function render() {
	    var _props = this.props;
	    var mapping = _props.mapping;
	    var validationErrors = _props.validationErrors;
	    var onSubmit = _props.onSubmit;
	    var onValid = _props.onValid;
	    var onValidSubmit = _props.onValidSubmit;
	    var onInvalid = _props.onInvalid;
	    var onInvalidSubmit = _props.onInvalidSubmit;
	    var onChange = _props.onChange;
	    var reset = _props.reset;
	    var preventExternalInvalidation = _props.preventExternalInvalidation;
	    var onSuccess = _props.onSuccess;
	    var onError = _props.onError;
	
	    var nonFormsyProps = _objectWithoutProperties(_props, ['mapping', 'validationErrors', 'onSubmit', 'onValid', 'onValidSubmit', 'onInvalid', 'onInvalidSubmit', 'onChange', 'reset', 'preventExternalInvalidation', 'onSuccess', 'onError']);
	
	    return React.createElement(
	      'form',
	      _extends({}, nonFormsyProps, { onSubmit: this.submit }),
	      this.props.children
	    );
	  }
	});
	
	if (!global.exports && !global.module && (!global.define || !global.define.amd)) {
	  global.Formsy = Formsy;
	}
	
	module.exports = Formsy;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },

/***/ 181:
/***/ function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	module.exports = {
	  arraysDiffer: function arraysDiffer(a, b) {
	    var isDifferent = false;
	    if (a.length !== b.length) {
	      isDifferent = true;
	    } else {
	      a.forEach(function (item, index) {
	        if (!this.isSame(item, b[index])) {
	          isDifferent = true;
	        }
	      }, this);
	    }
	    return isDifferent;
	  },
	
	  objectsDiffer: function objectsDiffer(a, b) {
	    var isDifferent = false;
	    if (Object.keys(a).length !== Object.keys(b).length) {
	      isDifferent = true;
	    } else {
	      Object.keys(a).forEach(function (key) {
	        if (!this.isSame(a[key], b[key])) {
	          isDifferent = true;
	        }
	      }, this);
	    }
	    return isDifferent;
	  },
	
	  isSame: function isSame(a, b) {
	    if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) !== (typeof b === 'undefined' ? 'undefined' : _typeof(b))) {
	      return false;
	    } else if (Array.isArray(a)) {
	      return !this.arraysDiffer(a, b);
	    } else if (typeof a === 'function') {
	      return a.toString() === b.toString();
	    } else if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object' && a !== null && b !== null) {
	      return !this.objectsDiffer(a, b);
	    }
	
	    return a === b;
	  },
	
	  find: function find(collection, fn) {
	    for (var i = 0, l = collection.length; i < l; i++) {
	      var item = collection[i];
	      if (fn(item)) {
	        return item;
	      }
	    }
	    return null;
	  }
	};

/***/ },

/***/ 211:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(49);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(182);
	
	var _FormsyWrapper = __webpack_require__(213);
	
	var _FormsyWrapper2 = _interopRequireDefault(_FormsyWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Shims and polyfills.
	__webpack_require__(175);
	__webpack_require__(174);
	__webpack_require__(176);
	__webpack_require__(145);
	
	__webpack_require__(489);
	
	_FormsyWrapper2.default.addAsyncValidationRule('isUniqueUser', function (value, optionalVal) {
	  return new Promise(function (resolve, reject) {
	    setTimeout(function () {
	      resolve('Success');
	    }, 2000);
	  });
	});
	
	_FormsyWrapper2.default.addAsyncValidationRule('isUniqueEmail', function (value, optionalVal) {
	  return new Promise(function (resolve, reject) {
	    setTimeout(function () {
	      reject('Fail');
	    }, 2000);
	  });
	});
	
	var App = function (_Component) {
	  _inherits(App, _Component);
	
	  function App(props) {
	    _classCallCheck(this, App);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(App).call(this, props));
	
	    _this.state = {
	      locale: 'en'
	    };
	    return _this;
	  }
	
	  _createClass(App, [{
	    key: 'onForm1Submit',
	    value: function onForm1Submit(formData) {
	      this.setState({ form1Result: 'validated data!' });
	    }
	  }, {
	    key: 'onForm2Submit',
	    value: function onForm2Submit(formData) {
	      this.setState({ form2Result: 'validated data!' });
	    }
	  }, {
	    key: 'onForm3Submit',
	    value: function onForm3Submit(formData) {
	      this.setState({ form3Result: 'validated data!' });
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick() {
	      var locale = this.state.locale;
	
	      locale = locale === 'en' ? 'zh' : 'en';
	      this.setState({ locale: locale });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'section',
	          null,
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Success asynchronous validation'
	          ),
	          _react2.default.createElement(
	            _FormsyWrapper2.default.Form,
	            { onValidSubmit: this.onForm1Submit.bind(this), className: 'form' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'username'
	              ),
	              _react2.default.createElement(_FormsyWrapper2.default.Input, {
	                name: 'username',
	                validations: 'isAlpha',
	                validationError: 'Username has to be letter only!',
	                asyncValidations: 'isUniqueUser',
	                asyncValidationErrors: { isUniqueUser: 'username has to be unique' },
	                required: true }),
	              _react2.default.createElement('span', { className: 'spinner' })
	            ),
	            _react2.default.createElement(
	              'button',
	              { type: 'submit' },
	              'submit'
	            ),
	            this.state && this.state.form1Result
	          )
	        ),
	        _react2.default.createElement(
	          'section',
	          null,
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Failed asynchronous validation'
	          ),
	          _react2.default.createElement(
	            _FormsyWrapper2.default.Form,
	            { onValidSubmit: this.onForm2Submit.bind(this), className: 'form' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'user email'
	              ),
	              _react2.default.createElement(_FormsyWrapper2.default.Input, {
	                name: 'email',
	                validations: 'isEmail',
	                validationError: 'This is not an email!',
	                asyncValidations: 'isUniqueEmail',
	                asyncValidationErrors: { isUniqueEmail: 'Email has to be unique' },
	                required: true }),
	              _react2.default.createElement('span', { className: 'spinner' })
	            ),
	            _react2.default.createElement(
	              'button',
	              { type: 'submit' },
	              'submit'
	            ),
	            this.state && this.state.form2Result
	          )
	        ),
	        _react2.default.createElement(
	          'section',
	          null,
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Failed asynchronous validation and translation setup'
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            'click button to change locale to ',
	            _react2.default.createElement(
	              'button',
	              { type: 'text', onClick: this.handleClick.bind(this) },
	              this.state.locale === 'en' ? 'zh' : 'en'
	            )
	          ),
	          _react2.default.createElement(
	            _FormsyWrapper2.default.Form,
	            { onValidSubmit: this.onForm3Submit.bind(this), className: 'form' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'user email'
	              ),
	              _react2.default.createElement(_FormsyWrapper2.default.Input, {
	                name: 'email',
	                validations: 'isEmail',
	                validationError: { en: 'This is not an email!', zh: '非email格式' },
	                asyncValidations: 'isUniqueEmail',
	                asyncValidationErrors: { isUniqueEmail: { en: 'Email has to be unique', zh: 'email必须是唯一的' } },
	                locale: this.state.locale,
	                required: true }),
	              _react2.default.createElement('span', { className: 'spinner' })
	            ),
	            _react2.default.createElement(
	              'button',
	              { type: 'submit' },
	              'submit'
	            ),
	            this.state && this.state.form3Result
	          )
	        )
	      );
	    }
	  }]);
	
	  return App;
	}(_react.Component);
	
	(0, _reactDom.render)(_react2.default.createElement(App, null), document.getElementById('app'));

/***/ },

/***/ 212:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp, _class3, _temp2;
	
	var _react = __webpack_require__(49);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _formsyReact = __webpack_require__(180);
	
	var _classnames = __webpack_require__(215);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _debounce = __webpack_require__(214);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// wrap async validation promise so the passed error can have information about validator name
	function wrapPromise(promise, validatorName) {
	  return new Promise(function (resolve, reject) {
	    return promise.then(function (payload) {
	      resolve(payload);
	    }, function (err) {
	      reject({ validatorName: validatorName, error: err });
	    });
	  });
	}
	
	var BaseInput = (_dec = (0, _formsyReact.Decorator)(), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(BaseInput, _Component);
	
	  function BaseInput(props, context) {
	    _classCallCheck(this, BaseInput);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(BaseInput).call(this, props, context));
	
	    _this.state = {
	      isValidating: false,
	      responseError: null
	    };
	    _this.debouncedHandleAsyncValidations = (0, _debounce2.default)(function () {
	      _this.handleAsyncValidations.call(_this, _this.state.fieldValue);
	    }, 300);
	    return _this;
	  }
	
	  _createClass(BaseInput, [{
	    key: 'handleChange',
	    value: function handleChange(e) {
	      // hide response error message if any
	      this.setState({ responseError: null });
	
	      var value = e.target.value;
	      var asyncValidations = this.props.asyncValidations;
	
	
	      this.props.setValue(value);
	      this.setState({ fieldValue: value });
	
	      // only start asynchronous validations when synchronous validations scucess
	      if (asyncValidations && this.props.isValid()) {
	        this.debouncedHandleAsyncValidations();
	      }
	    }
	  }, {
	    key: 'handleAsyncValidations',
	    value: function handleAsyncValidations(value) {
	      var _this2 = this;
	
	      if (!value) {
	        return;
	      }
	      var asyncValidations = this.props.asyncValidations;
	      var formsyWrapper = this.context.formsyWrapper;
	
	      var asyncValidationRules = formsyWrapper.getAsyncValidationRules();
	      var asyncValidationPromise = [];
	
	      this.setState({ isValidating: true });
	
	      if (typeof asyncValidations === 'string') {
	        asyncValidations.split(',').forEach(function (validatorName) {
	          var validationMethod = asyncValidationRules[validatorName];
	          if (validationMethod) {
	            var p = wrapPromise(validationMethod(value), validatorName);
	            asyncValidationPromise.push(p);
	          }
	        });
	      } else if ((typeof asyncValidations === 'undefined' ? 'undefined' : _typeof(asyncValidations)) === 'object') {
	        Object.keys(asyncValidations).forEach(function (validatorName) {
	          var validationMethod = asyncValidationRules[validatorName];
	          if (validationMethod) {
	            var p = wrapPromise(validationMethod(value, asyncValidations[validatorName]), validatorName);
	            asyncValidationPromise.push(p);
	          }
	        });
	      }
	      return Promise.all(asyncValidationPromise).then(function () {
	        formsyWrapper.setAsyncValidationState(true);
	        return _this2.setState({ isValidating: false });
	      }).catch(function (err) {
	        var msg = _this2.getAsyncErrorMessage(err.validatorName);
	
	        formsyWrapper.setAsyncValidationState(false);
	        return _this2.setState({ isValidating: false, responseError: msg });
	      });
	    }
	  }, {
	    key: 'getAsyncErrorMessage',
	    value: function getAsyncErrorMessage(validatorName) {
	      var _props = this.props;
	      var asyncValidationErrors = _props.asyncValidationErrors;
	      var locale = _props.locale;
	
	      if (asyncValidationErrors && asyncValidationErrors[validatorName]) {
	        return locale && asyncValidationErrors[validatorName][locale] ? asyncValidationErrors[validatorName][locale] : asyncValidationErrors[validatorName];
	      }
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props;
	      var type = _props2.type;
	      var name = _props2.name;
	      var className = _props2.className;
	      var showRequired = _props2.showRequired;
	      var showError = _props2.showError;
	      var getValue = _props2.getValue;
	      var getErrorMessage = _props2.getErrorMessage;
	
	      var classes = (0, _classnames2.default)(className, {
	        'error': showError() || this.state.responseError,
	        'required': showRequired(),
	        'validating': this.state.isValidating
	      });
	      var errorMessage = showError() ? getErrorMessage() : this.state.responseError;
	
	      return _react2.default.createElement(
	        'div',
	        { className: classes },
	        _react2.default.createElement('input', {
	          type: type || 'text',
	          name: name,
	          value: getValue() || '',
	          onChange: this.handleChange.bind(this) }),
	        _react2.default.createElement(
	          'span',
	          { className: 'errorInfo' },
	          errorMessage
	        )
	      );
	    }
	  }]);
	
	  return BaseInput;
	}(_react.Component), _class2.propTypes = {
	  locale: _react.PropTypes.string,
	  value: _react.PropTypes.any,
	  type: _react.PropTypes.string,
	  name: _react.PropTypes.string,
	  autoComplete: _react.PropTypes.string,
	  setValue: _react.PropTypes.func,
	  getValue: _react.PropTypes.func,
	  maxLength: _react.PropTypes.number,
	  asyncValidations: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.object]),
	  asyncValidationErrors: _react.PropTypes.object,
	  className: _react.PropTypes.string,
	  showRequired: _react.PropTypes.func,
	  showError: _react.PropTypes.func,
	  getErrorMessage: _react.PropTypes.func
	}, _class2.contextTypes = {
	  formsyWrapper: _react.PropTypes.object
	}, _temp)) || _class);
	
	/*
	*
	*/
	
	var FormsyInput = (_temp2 = _class3 = function (_Component2) {
	  _inherits(FormsyInput, _Component2);
	
	  function FormsyInput() {
	    _classCallCheck(this, FormsyInput);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(FormsyInput).apply(this, arguments));
	  }
	
	  _createClass(FormsyInput, [{
	    key: 'resetValue',
	    value: function resetValue() {
	      this.refs.baseInput.resetValue();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props;
	      var validationError = _props3.validationError;
	      var validationErrors = _props3.validationErrors;
	      var locale = _props3.locale;
	
	      var parsedObj, newProps;
	
	      if (locale && validationErrors) {
	        parsedObj = {};
	        Object.keys(validationErrors).forEach(function (validatorName) {
	          parsedObj[validatorName] = validationErrors[validatorName][locale] ? validationErrors[validatorName][locale] : validationErrors[validatorName];
	        });
	        newProps = _extends({}, this.props, { validationErrors: parsedObj });
	        return _react2.default.createElement(BaseInput, _extends({}, newProps, { ref: 'baseInput' }));
	      }
	
	      if (locale && validationError) {
	        if (typeof validationError === 'string') {
	          parsedObj = validationError;
	        }
	        if ((typeof validationError === 'undefined' ? 'undefined' : _typeof(validationError)) === 'object') {
	          parsedObj = validationError[locale] ? validationError[locale] : validationError.toString();
	        }
	        newProps = _extends({}, this.props, { validationError: parsedObj });
	        return _react2.default.createElement(BaseInput, _extends({}, newProps, { ref: 'baseInput' }));
	      }
	
	      return _react2.default.createElement(BaseInput, _extends({}, this.props, {
	        ref: 'baseInput' }));
	    }
	  }]);
	
	  return FormsyInput;
	}(_react.Component), _class3.propTypes = {
	  locale: _react.PropTypes.string,
	  validations: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.object]),
	  validationError: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.object]),
	  validationErrors: _react.PropTypes.object
	}, _temp2);
	exports.default = FormsyInput;

/***/ },

/***/ 213:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(49);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _formsyReact = __webpack_require__(180);
	
	var _formsyReact2 = _interopRequireDefault(_formsyReact);
	
	var _FormsyInput = __webpack_require__(212);
	
	var _FormsyInput2 = _interopRequireDefault(_FormsyInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormsyWrapper = {};
	var asyncValidationRules = {};
	
	FormsyWrapper.addAsyncValidationRule = function (name, func) {
	  asyncValidationRules[name] = func;
	};
	
	var FormsyFormWrapper = (_temp = _class = function (_Component) {
	  _inherits(FormsyFormWrapper, _Component);
	
	  function FormsyFormWrapper(props) {
	    _classCallCheck(this, FormsyFormWrapper);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(FormsyFormWrapper).call(this, props));
	
	    _this.state = {
	      isValid: false,
	      formClass: ''
	    };
	    return _this;
	  }
	
	  _createClass(FormsyFormWrapper, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        formsyWrapper: {
	          getAsyncValidationRules: this.getAsyncValidationRules,
	          setAsyncValidationState: this.setAsyncValidationState.bind(this)
	        }
	      };
	    }
	  }, {
	    key: 'getAsyncValidationRules',
	    value: function getAsyncValidationRules() {
	      return asyncValidationRules;
	    }
	  }, {
	    key: 'setAsyncValidationState',
	    value: function setAsyncValidationState(isValid) {
	      this.setState({ isValid: isValid });
	    }
	
	    /* Porting <Formsy.Form /> reset() */
	
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.refs.formsy.reset();
	    }
	
	    /* Porting <Formsy.Form /> getModel() */
	
	  }, {
	    key: 'getModel',
	    value: function getModel() {
	      this.refs.formsy.getModel();
	    }
	
	    /* Porting <Formsy.Form /> updateInputsWithError() */
	
	  }, {
	    key: 'updateInputsWithError',
	    value: function updateInputsWithError(errors) {
	      this.refs.formsy.updateInputsWithError(errors);
	    }
	
	    /* Porting <Formsy.Form /> onValid() */
	
	  }, {
	    key: 'onValid',
	    value: function onValid() {
	      var onValid = this.props.onValid;
	      var isValid = this.state.isValid;
	
	      if (isValid) {
	        return onValid && onValid();
	      }
	    }
	
	    /* Porting <Formsy.Form /> onInvalid() */
	
	  }, {
	    key: 'onInvalid',
	    value: function onInvalid() {
	      var onInvalid = this.props.onInvalid;
	      var isValid = this.state.isValid;
	
	      if (!isValid) {
	        return onInvalid && onInvalid();
	      }
	    }
	
	    /* Porting <Formsy.Form /> onChange() */
	
	  }, {
	    key: 'onChange',
	    value: function onChange(currentValues, isChanged) {
	      var onChange = this.props.onChange;
	
	      this.setState({ formClass: '' });
	      return onChange && onChange(currentValues, isChanged);
	    }
	
	    /* Porting <Formsy.Form /> onInvalidSubmit() */
	
	  }, {
	    key: 'onInvalidSubmit',
	    value: function onInvalidSubmit(data, resetForm, invalidateForm) {
	      var onInvalidSubmit = this.props.onInvalidSubmit;
	
	      this.setState({ formClass: 'showFormError' });
	      return onInvalidSubmit && onInvalidSubmit(data, resetForm, invalidateForm);
	    }
	
	    /* Porting <Formsy.Form /> onValidSubmit() */
	
	  }, {
	    key: 'onValidSubmit',
	    value: function onValidSubmit(data, resetForm, invalidateForm) {
	      var onValidSubmit = this.props.onValidSubmit;
	      var isValid = this.state.isValid;
	
	      if (isValid) {
	        return onValidSubmit && onValidSubmit(data, resetForm, invalidateForm);
	      }
	      return false;
	    }
	
	    /* Porting <Formsy.Form /> onSubmit() */
	
	  }, {
	    key: 'onSubmit',
	    value: function onSubmit(data, resetForm, invalidateForm) {
	      var onSubmit = this.props.onSubmit;
	      var isValid = this.state.isValid;
	
	      if (isValid) {
	        return onSubmit && onSubmit(data, resetForm, invalidateForm);
	      }
	      return false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var newProps = _extends({}, this.props, {
	        onValid: this.onValid.bind(this),
	        onInvalid: this.onInvalid.bind(this),
	        onChange: this.onChange.bind(this),
	        onSubmit: this.onSubmit.bind(this),
	        onInvalidSubmit: this.onInvalidSubmit.bind(this),
	        onValidSubmit: this.onValidSubmit.bind(this),
	        className: (this.props.className || '') + ' ' + this.state.formClass
	      });
	      return _react2.default.createElement(
	        _formsyReact2.default.Form,
	        _extends({}, newProps, { ref: 'formsy' }),
	        this.props.children
	      );
	    }
	  }]);
	
	  return FormsyFormWrapper;
	}(_react.Component), _class.propTypes = {
	  children: _react.PropTypes.any
	}, _class.childContextTypes = {
	  formsyWrapper: _react.PropTypes.object
	}, _temp);
	
	
	FormsyWrapper.Form = FormsyFormWrapper;
	FormsyWrapper.Input = _FormsyInput2.default;
	
	exports.default = FormsyWrapper;

/***/ },

/***/ 214:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _arguments = arguments;
	var debounce = function debounce(func, threshold, execAsap) {
	  var timeout = null;
	
	  return function () {
	    var that = undefined;
	    var args = _arguments.length >= 1 ? Array.prototype.slice.call(_arguments, 0) : [];
	    var delayed = function delayed() {
	      if (!execAsap) {
	        func.apply(that, args);
	      }
	      timeout = null;
	      return timeout;
	    };
	    if (timeout) {
	      clearTimeout(timeout);
	    } else if (execAsap) {
	      func.apply(that, args);
	    }
	    timeout = setTimeout(delayed, threshold || 100);
	    return timeout;
	  };
	};
	
	exports.default = debounce;

/***/ },

/***/ 215:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },

/***/ 397:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(398)();
	// imports
	
	
	// module
	exports.push([module.id, "html{font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted}dfn{font-style:italic}mark{background:#ff0;color:#000}b,strong{font-weight:700}h1{font-size:2em;margin:.67em 0}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{box-sizing:content-box;height:0}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{color:inherit;font:inherit;margin:0}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{cursor:pointer;-webkit-appearance:button}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}input{line-height:normal}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{-webkit-appearance:textfield;box-sizing:content-box}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}legend{border:0;padding:0}textarea{overflow:auto}optgroup{font-weight:700}table{border-collapse:collapse;border-spacing:0}td,th{padding:0}a,abbr,acronym,address,applet,big,blockquote,body,caption,cite,code,dd,del,dfn,div,dl,dt,em,fieldset,form,h1,h2,h3,h4,h5,h6,html,iframe,img,ins,kbd,label,legend,li,object,ol,p,pre,q,s,samp,small,span,strike,strong,sub,sup,table,tbody,td,tfoot,th,thead,tr,tt,ul,var{margin:0;padding:0;border:0;outline:0;font-weight:inherit;font-style:inherit;font-family:inherit;font-size:100%;vertical-align:baseline}body{line-height:1;color:#000;background:#fff}ol,ul{list-style:none}table{border-collapse:separate;border-spacing:0}caption,table,td,th{vertical-align:middle}caption,td,th{text-align:left;font-weight:400}a img{border:none}*{box-sizing:border-box}body{font-size:16px;color:#4e4e4e}h2{font-size:1.4em}.container{max-width:40em;width:100%;margin:auto;padding:0 1em}section{padding:1.2em 0}form{margin:1.2em 0}.form-item{position:relative}.form-item label{text-transform:uppercase}.form-item>div{margin:.75em 0}.form-item input{border:1px solid #d8d8d8;padding:.5em;width:100%}.form-item input:active,.form-item input:focus{outline:none}.form-item .errorInfo{color:#c9391f;display:none}.form-item .error input{border:1px solid #c9391f}.form-item .error .errorInfo{display:block}.showFormError .required input{border-color:#c9391f}.spinner{display:none;position:absolute;right:0;top:10px;width:32px;height:32px;clear:both;margin:20px auto;border:4px solid rgba(0,0,0,.25);border-top:4px solid #000;border-radius:50%;-webkit-animation:spinning .6s infinite linear;animation:spinning .6s infinite linear}.validating+.spinner{display:inline-block}@-webkit-keyframes spinning{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}@keyframes spinning{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}", ""]);
	
	// exports


/***/ },

/***/ 398:
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },

/***/ 414:
/***/ function(module, exports) {

	function toObj(source) {
	  return Object.keys(source).reduce(function (output, key) {
	    var parentKey = key.match(/[^\[]*/i);
	    var paths = key.match(/\[.*?\]/g) || [];
	    paths = [parentKey[0]].concat(paths).map(function (key) {
	      return key.replace(/\[|\]/g, '');
	    });
	    var currentPath = output;
	    while (paths.length) {
	      var pathKey = paths.shift();
	
	      if (pathKey in currentPath) {
	        currentPath = currentPath[pathKey];
	      } else {
	        currentPath[pathKey] = paths.length ? isNaN(paths[0]) ? {} : [] : source[key];
	        currentPath = currentPath[pathKey];
	      }
	    }
	
	    return output;
	  }, {});
	}
	
	function fromObj(obj) {
	  function recur(newObj, propName, currVal) {
	    if (Array.isArray(currVal) || Object.prototype.toString.call(currVal) === '[object Object]') {
	      Object.keys(currVal).forEach(function(v) {
	        recur(newObj, propName + "[" + v + "]", currVal[v]);
	      });
	      return newObj;
	    }
	
	    newObj[propName] = currVal;
	    return newObj;
	  }
	
	  var keys = Object.keys(obj);
	  return keys.reduce(function(newObj, propName) {
	    return recur(newObj, propName, obj[propName]);
	  }, {});
	}
	
	module.exports = {
	  fromObj: fromObj,
	  toObj: toObj
	}

/***/ },

/***/ 415:
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = global.React || __webpack_require__(49);
	var Mixin = __webpack_require__(122);
	module.exports = function () {
	  return function (Component) {
	    return React.createClass({
	      mixins: [Mixin],
	      render: function render() {
	        return React.createElement(Component, _extends({
	          setValidations: this.setValidations,
	          setValue: this.setValue,
	          resetValue: this.resetValue,
	          getValue: this.getValue,
	          hasValue: this.hasValue,
	          getErrorMessage: this.getErrorMessage,
	          getErrorMessages: this.getErrorMessages,
	          isFormDisabled: this.isFormDisabled,
	          isValid: this.isValid,
	          isPristine: this.isPristine,
	          isFormSubmitted: this.isFormSubmitted,
	          isRequired: this.isRequired,
	          showRequired: this.showRequired,
	          showError: this.showError,
	          isValidValue: this.isValidValue
	        }, this.props));
	      }
	    });
	  };
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },

/***/ 416:
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = global.React || __webpack_require__(49);
	var Mixin = __webpack_require__(122);
	module.exports = function (Component) {
	  return React.createClass({
	    displayName: 'Formsy(' + getDisplayName(Component) + ')',
	    mixins: [Mixin],
	    render: function render() {
	      return React.createElement(Component, _extends({
	        setValidations: this.setValidations,
	        setValue: this.setValue,
	        resetValue: this.resetValue,
	        getValue: this.getValue,
	        hasValue: this.hasValue,
	        getErrorMessage: this.getErrorMessage,
	        getErrorMessages: this.getErrorMessages,
	        isFormDisabled: this.isFormDisabled,
	        isValid: this.isValid,
	        isPristine: this.isPristine,
	        isFormSubmitted: this.isFormSubmitted,
	        isRequired: this.isRequired,
	        showRequired: this.showRequired,
	        showError: this.showError,
	        isValidValue: this.isValidValue
	      }, this.props));
	    }
	  });
	};
	
	function getDisplayName(Component) {
	  return Component.displayName || Component.name || (typeof Component === 'string' ? Component : 'Component');
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },

/***/ 417:
/***/ function(module, exports) {

	'use strict';
	
	var _isExisty = function _isExisty(value) {
	  return value !== null && value !== undefined;
	};
	
	var isEmpty = function isEmpty(value) {
	  return value === '';
	};
	
	var validations = {
	  isDefaultRequiredValue: function isDefaultRequiredValue(values, value) {
	    return value === undefined || value === '';
	  },
	  isExisty: function isExisty(values, value) {
	    return _isExisty(value);
	  },
	  matchRegexp: function matchRegexp(values, value, regexp) {
	    return !_isExisty(value) || isEmpty(value) || regexp.test(value);
	  },
	  isUndefined: function isUndefined(values, value) {
	    return value === undefined;
	  },
	  isEmptyString: function isEmptyString(values, value) {
	    return isEmpty(value);
	  },
	  isEmail: function isEmail(values, value) {
	    return validations.matchRegexp(values, value, /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i);
	  },
	  isUrl: function isUrl(values, value) {
	    return validations.matchRegexp(values, value, /^(https?|s?ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i);
	  },
	  isTrue: function isTrue(values, value) {
	    return value === true;
	  },
	  isFalse: function isFalse(values, value) {
	    return value === false;
	  },
	  isNumeric: function isNumeric(values, value) {
	    if (typeof value === 'number') {
	      return true;
	    }
	    return validations.matchRegexp(values, value, /^[-+]?(?:\d*[.])?\d+$/);
	  },
	  isAlpha: function isAlpha(values, value) {
	    return validations.matchRegexp(values, value, /^[A-Z]+$/i);
	  },
	  isAlphanumeric: function isAlphanumeric(values, value) {
	    return validations.matchRegexp(values, value, /^[0-9A-Z]+$/i);
	  },
	  isInt: function isInt(values, value) {
	    return validations.matchRegexp(values, value, /^(?:[-+]?(?:0|[1-9]\d*))$/);
	  },
	  isFloat: function isFloat(values, value) {
	    return validations.matchRegexp(values, value, /^(?:[-+]?(?:\d+))?(?:\.\d*)?(?:[eE][\+\-]?(?:\d+))?$/);
	  },
	  isWords: function isWords(values, value) {
	    return validations.matchRegexp(values, value, /^[A-Z\s]+$/i);
	  },
	  isSpecialWords: function isSpecialWords(values, value) {
	    return validations.matchRegexp(values, value, /^[A-Z\s\u00C0-\u017F]+$/i);
	  },
	  isLength: function isLength(values, value, length) {
	    return !_isExisty(value) || isEmpty(value) || value.length === length;
	  },
	  equals: function equals(values, value, eql) {
	    return !_isExisty(value) || isEmpty(value) || value == eql;
	  },
	  equalsField: function equalsField(values, value, field) {
	    return value == values[field];
	  },
	  maxLength: function maxLength(values, value, length) {
	    return !_isExisty(value) || value.length <= length;
	  },
	  minLength: function minLength(values, value, length) {
	    return !_isExisty(value) || isEmpty(value) || value.length >= length;
	  }
	};
	
	module.exports = validations;

/***/ },

/***/ 488:
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(true) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },

/***/ 489:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(397);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(488)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../node_modules/css-loader/index.js!./../node_modules/stylus-loader/index.js!./main.styl", function() {
				var newContent = require("!!./../node_modules/css-loader/index.js!./../node_modules/stylus-loader/index.js!./main.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }

});


/** WEBPACK FOOTER **
 ** app.js
 **/